module.exports = __webpack_public_path__ + "img/3c3d1a8.jpg";